import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserPlus, LayoutList, LayoutGrid } from "lucide-react";
import { useState } from "react";

export default function CreatorList({ creators = [] }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [layout, setLayout] = useState("list");

  if (creators.length === 0) {
    return (
      <div data-testid="creator-list-empty" className="px-4 py-12 text-center text-sm text-[#999]">
        {t("feed.no_creators")}
      </div>
    );
  }

  return (
    <div data-testid="creator-list">
      {/* Layout Toggle */}
      <div className="flex items-center justify-end gap-1 px-4 py-2 border-b border-[#E5E5E5]">
        <button
          data-testid="creator-layout-list"
          onClick={() => setLayout("list")}
          className={`p-1.5 transition-colors ${layout === "list" ? "text-[#0A0A0A]" : "text-[#CCC]"}`}
        >
          <LayoutList size={18} />
        </button>
        <button
          data-testid="creator-layout-grid"
          onClick={() => setLayout("grid")}
          className={`p-1.5 transition-colors ${layout === "grid" ? "text-[#0A0A0A]" : "text-[#CCC]"}`}
        >
          <LayoutGrid size={18} />
        </button>
      </div>

      {layout === "list" ? (
        <div className="divide-y divide-[#E5E5E5]">
          {creators.map((c) => (
            <button
              key={c.person_id}
              data-testid={`creator-item-${c.handle}`}
              onClick={() => navigate(`/user/${c.handle}`)}
              className="w-full flex items-center gap-3 px-4 py-3 hover:bg-[#FAFAFA] transition-colors active:bg-[#F0F0F0]"
            >
              {c.avatar_url ? (
                <img src={c.avatar_url} alt="" className="w-12 h-12 rounded-full object-cover" />
              ) : (
                <div className="w-12 h-12 rounded-full bg-[#E5E5E5] flex items-center justify-center text-base font-bold text-[#999]">
                  {(c.display_name || "?")[0]}
                </div>
              )}
              <div className="flex-1 min-w-0 text-left">
                <p className="text-sm font-semibold text-[#0A0A0A] truncate">{c.display_name}</p>
                <p className="text-xs text-[#BBB] mt-0.5">
                  {t("public_profile.followers")}: {c.follower_count || 0} · {t("public_profile.posts")}: {c.post_count || 0}
                </p>
              </div>
              <div className="shrink-0 text-[#999]">
                <UserPlus size={18} />
              </div>
            </button>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-px bg-[#E5E5E5]">
          {creators.map((c) => (
            <button
              key={c.person_id}
              data-testid={`creator-grid-${c.handle}`}
              onClick={() => navigate(`/user/${c.handle}`)}
              className="bg-white p-4 flex flex-col items-center gap-2 hover:bg-[#FAFAFA] transition-colors"
            >
              {c.avatar_url ? (
                <img src={c.avatar_url} alt="" className="w-16 h-16 rounded-full object-cover" />
              ) : (
                <div className="w-16 h-16 rounded-full bg-[#E5E5E5] flex items-center justify-center text-lg font-bold text-[#999]">
                  {(c.display_name || "?")[0]}
                </div>
              )}
              <p className="text-sm font-semibold text-[#0A0A0A] truncate max-w-full">{c.display_name}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
